<!-- prettier-ignore -->
<div
    @fadeInOut
    *ngIf="impersonatedUserName$ | async as impersonatedUser"
    role="alert"
    class="bg-critical text-critical-contrast row gx-0 align-items-center justify-content-center justify-content-sm-between m-0"
    style="border-radius: 0"
>
    <div class="col-12 col-lg-auto text-center">
        <p class="m-0">
            <tabler-icon
                style="height: 20px; width: 20px; vertical-align: bottom"
                name="alert-circle"
                class="me-2 d-none d-lg-inline-block"
            ></tabler-icon>
            <strong>Heads up!</strong>
            You're currently acting on behalf of
            <strong>{{ impersonatedUser }}</strong>.
        </p>
    </div>
    <div class="col-12 col-lg-auto mt-2 mt-lg-0 justify-content-center text-center">
        <a
            class="text-critical-contrast"
            [routerLink]="['', { outlets: { modal: ['impersonation', 'switch-user'] } }]"
        >
            <tabler-icon
                style="height: 20px; width: 20px; vertical-align: bottom"
                name="user-search"
                class="me-1 d-lg-inline-block"
            ></tabler-icon>
            Switch user
        </a>
        <span class="mx-2">|</span>
        <a
            class="link text-critical-contrast"
            href="#"
            (click)="endImpersonation($event)"
        >
            <tabler-icon
                style="height: 20px; width: 20px; vertical-align: bottom"
                name="user-x"
                class="me-1 d-lg-inline-block"
            ></tabler-icon>
            Switch back to <strong>{{ userFullName$ | async }}</strong>
        </a>
    </div>
</div>
